// assets
import billingIcon from '../assets/images/icons/billing.svg';

const billing = {
  id: 'billing',
  type: 'group',
  children: [
    {
      id: 'billing',
      title: 'Billing',
      type: 'collapse',
      icon: billingIcon,
      children: [
        {
          id: 'BillingTool',
          title: 'Billing Tool',
          type: 'item',
          url: '/billing/BillingTool',
          breadcrumbs: false,
          featureName: 'Billing',
        },
        {
          id: 'cpiSetup',
          title: 'CPI Setup',
          type: 'item',
          url: '/billing/cpiSetup',
          breadcrumbs: false,
          featureName: 'Billing',
        },
      ],
    },
  ],
};

export default billing;
